module.exports = __webpack_public_path__ + "img/manymarkers.9ba17719.jpg";